import Image from 'next/image'
import React from 'react'

import ChallengesIcon from '../../assets/challengesIcon.svg'
import HandsOnProjectsIcon from '../../assets/handsOnProjectsIcon.svg'
import ThreadIcon from '../../assets/threadIcon.svg'
import WorkShopIcon from '../../assets/workshopIcon.svg'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'

const data = [
  {
    icon: ChallengesIcon.src,
    count: '100+',
    heading: 'Challenges',
    para: 'Ace your problem-solving skill by solving hand-selected questions.'
  },
  {
    icon: HandsOnProjectsIcon.src,
    count: '20+',
    heading: 'Hands-On Projects',
    para: 'Create real-world apps from scratch and build stellar portfolio projects'
  },
  {
    icon: WorkShopIcon.src,
    count: '10+',
    heading: 'Skill Building workshops',
    para: 'Expand your knowledge through insider tips and tricks from industry experts'
  }
]

const LevelUpSection = () => {
  return (
    <SectionLayout>
      <SectionHeader className="flex flex-col">
        <span className="text-primary">Level Up</span>
        <span className="text-2xl py-4 font-medium">
          Through Our Structured Training Approach
        </span>
      </SectionHeader>
      <SectionContent className="relative">
        <div className="flex flex-wrap gap-6 z-20 items-center justify-center">
          {data.map((d) => (
            <div
              key={d.heading}
              className="bg-[#3c3c7899] flex flex-col items-center rounded-md py-4 sm:max-w-[300px] gap-3 px-10">
              <div>
                <Image src={d.icon} alt={'icon'} width={130} height={130} />
              </div>

              <div className="text-primary font-semibold text-2xl">
                {d.count}
              </div>

              <div className="font-semibold text-lg">{d.heading}</div>

              <div className="text-[#A1A1AA] text-center">{d.para}</div>
            </div>
          ))}
        </div>

        <Image
          src={ThreadIcon.src}
          height={100}
          width={900}
          alt={'icon'}
          className="hidden sm:block absolute top-[-25%] left-[-1%] h-full w-full object-fill"
        />
      </SectionContent>
    </SectionLayout>
  )
}

export default LevelUpSection
